import { render, staticRenderFns } from "./AppPromote.vue?vue&type=template&id=099f5051&scoped=true&"
import script from "./AppPromote.vue?vue&type=script&lang=js&"
export * from "./AppPromote.vue?vue&type=script&lang=js&"
import style0 from "./AppPromote.vue?vue&type=style&index=0&id=099f5051&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "099f5051",
  null
  
)

export default component.exports